/* eslint-disable import/prefer-default-export */
import { TranslationMapMessages, MapMessages } from "../interfaces";

export const messages: TranslationMapMessages = {
  [MapMessages.updateVehicleCurrentPosition]: "Update vehicle's current position",
  [MapMessages.errorFetchingAddressData]: "Error fetching address data",
  [MapMessages.locationSearchTitle]: "Location search",
  [MapMessages.typeLocationLabel]: "Type location",
  [MapMessages.allVehiclesSearchLabel]: "Search by plate, description or code",
  [MapMessages.addressSearchLabel]: "Search by address",
  [MapMessages.route]: "Route",
  [MapMessages.outwardTrip]: "Outward trip",
  [MapMessages.returnTrip]: "Return",
  [MapMessages.names]: "Names",
  [MapMessages.licensePlates]: "License plates",
  [MapMessages.alerts]: "Alerts",
  [MapMessages.states]: "States",
  [MapMessages.events]: "Events",
  [MapMessages.viewLocation]: "View location",
  [MapMessages.zmrc]: "ZMRC",
  [MapMessages.invalidPolygon]: "Invalid polygon",
  [MapMessages.point]: "Point",
  [MapMessages.stopped]: "stopped",
  [MapMessages.distanceToConstruction]: "Distance to job site",
  [MapMessages.showOnMap]: "Show on map",
  [MapMessages.areas]: "Areas",
  [MapMessages.construction]: "Job site",
  [MapMessages.constructionNotLocked]: "Job site not fixed yet",
  [MapMessages.invoiceAddress]: "Delivery ticket address",
  [MapMessages.plant]: "Plant",
  [MapMessages.trustedLocation]: "Trusted location",
  [MapMessages.discharges]: "Discharges",
  [MapMessages.dischargeInConstruction]: "Discharge at the job site",
  [MapMessages.dischargeOutsideConstruction]: "Discharge outside the job site",
  [MapMessages.alertTag]: "Alert",
  [MapMessages.eventTag]: "Event",
  [MapMessages.stateTag]: "State",
  [MapMessages.legendHint]: "Alerts (red) need a look; events are informational.",
  [MapMessages.legendOrderHint]: "Numbers mark what happened in the travel, in timeline order.",
  [MapMessages.timeline]: "Timeline",
  [MapMessages.replayPlay]: "Play route",
  [MapMessages.replayPause]: "Pause",
  [MapMessages.travelMoment]: "Travel moment",
  [MapMessages.playbackSpeed]: "Playback speed",
  [MapMessages.replayFromHere]: "Play from here",
  [MapMessages.replayHint]: "Right-click the route to play from that point.",
  [MapMessages.fullscreen]: "Full screen",
  [MapMessages.exitFullscreen]: "Exit full screen",
  [MapMessages.fullscreenHint]: "Full screen: map, replay, timeline and travel data side by side. The best way to see how the travel went.",
  [MapMessages.automaticTravel]: "Automatic travel (no delivery note): no job site recognized in this travel",
  [MapMessages.automaticConstruction]: "automatic job site",
  [MapMessages.travelTime]: "Travel time",
  [MapMessages.fromConstruction]: "from the job site",
  [MapMessages.constructionHelp]: "Job site point and the radius used for At job site and Discharging.\nSolid: discharges have confirmed the place and it is now fixed.",
  [MapMessages.constructionNotLockedHelp]: "The point still follows the discharges: it may move with the next deliveries until they confirm the place.",
  [MapMessages.invoiceAddressHelp]: "Where the delivery ticket address falls on the map.\nReference only: the job site is the yellow circle.",
  [MapMessages.plantHelp]: "Plant where the travel started and returned to.",
  [MapMessages.trustedLocationHelp]: "Registered place, such as a workshop, fuel station or parking lot.\nWhile the truck is there, the state is At trusted location.",
  [MapMessages.dischargeInConstructionHelp]: "Point where the discharge was recorded inside the job site.",
  [MapMessages.dischargeOutsideConstructionHelp]: "Point where the discharge was recorded outside the job site.\nIt raises the improper discharge alert.",
  [MapMessages.addressSearchLoading]: "Searching addresses...",
  [MapMessages.addressSearchUnavailable]: "The address search is unavailable right now. Try again or type the coordinates (latitude, longitude)."
};
